import { LfSorting } from '@leafio/ui/table';

export const QUERY_PARAMS = {
  BEARER_TOKEN: 'bearer_token',
  RETURN_URL: 'returnUrl',
  TOKEN: 'token',
};

export const DEFAULT_PER_PAGE = 25;
export const EMPTY_SORTING: LfSorting<unknown> = {
  property: null,
  direction: 'desc',
};
